export const GET_OFFERS = 'GET_OFFERS';
export const SELECT_OFFER = 'SELECT_OFFER';
